<template>
	<div class="pay-rate-editor">

		<table class="table table-striped table-bordered config-table">
			<thead>
				<tr>
					<th>Pay Type</th>
					<th>Schoox Job Names</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>Salaried</th>
					<td>
						<draggable class="pay-type-container" :list="salary" :options="options">
							   <div v-for="name in salary" class="pay-dragger">{{name}}</div>
						</draggable>
					</td>
				</tr>
				<tr>
					<th>Hourly</th>
					<td>
						<draggable class="pay-type-container" :list="hourly" :options="options"  @add="update" @remove="update">
							   <div v-for="name in hourly" class="pay-dragger">{{name}}</div>
						</draggable>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
// import _ from 'underscore'
import draggable from 'vuedraggable'

export default {
	props: {
		'salary': {
			type: Array,
			default: () => []
		},
		'hourly': {
			type: Array,
			default: () => []
		}
	},
	components: { draggable },
	computed: {
		options () {
			return {
				group: {
					name: 'pay',
					put: true,
					clone: false
				},
				sort: false
			}
		}
	},
	methods: {
		cancel () {
			this.$emit('cancel')
		},
		finish () {
			this.$emit('finish', {})
		},
		update () {
			this.$emit('update', this.hourly)
		}
	}

}

</script>
<style>
	.pay-type-container{
		min-height: 30px;
		overflow: auto;
	}
	.pay-dragger{
		display: inline-block;
		vertical-align: top;
		background: #ffffff;
		border:  1px solid #333;
		margin-right: 10px;
		margin-bottom: 8px;
		padding: 2px 6px;
	}

</style>


// WEBPACK FOOTER //
// PayTypeEditor.vue?0cad155a